import React from "react";
import AttendanceConfig from "./AttendanceConfig";

const AttendanceConfigSection = ({ userDetails, selectedClient }) => {
  return (
    <div className='grid-item-container'>
      <AttendanceConfig userDetails={userDetails} selectedClient={selectedClient} />
    </div>
  );
};

export default AttendanceConfigSection;
